import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem, MessageService, TreeNode } from 'primeng/api';
import { DocumentSearchResult } from '../../../../document/models/documentSearchResult';
import { TrainingItemDetails } from '../../models/trainingItemDetails';
import { DocumentLibrarySearchComponent } from '../../../../document-search/document-library-search/document-library-search.component';
import { EqmsScopeManagementService } from '../../../../shared/services/eqms-scope-management.service';
import { EmployeesTrainingPlanPersistenceService } from '../../services/employees-training-plan-persistence.service';
import { EmployeesTrainingPlanService } from '../../services/employees-training-plan.service';
import { cloneDeep } from 'lodash-es';
import { catchError, throwError } from 'rxjs';
import { EmployeesTrainingPlanConstants } from '../../employees-training-plan.constants';
import { UserTrainingPlanDTO } from '../../../../my-space/user-training-plan/models/user-training-plan';
import { SelectedUserScopesDTO } from '../../models/selectedUserScopesDTO';
import { TrainingPlanDetailsDto } from '../../../../my-space/user-training-plan/models/trainingPlanDetailsDto';
import { UserProfileConstants } from '../../../../my-space/user-profile/user-profile-constants';

@Component({
  selector: 'app-employee-training-plan-document-details',
  templateUrl: './employee-training-plan-document-details.component.html',
  styleUrls: ['./employee-training-plan-document-details.component.scss']
})
export class EmployeeTrainingPlanDocumentDetailsComponent implements OnInit {
  @Output() activateTabIndex = new EventEmitter<number>();
  documentSearchResult : DocumentSearchResult[] = [];
  isTrainingPlanSaveInProgress: boolean = false;
  TrainingPlanSaveInProgressMessage : string = EmployeesTrainingPlanConstants.EmployeeTrainingPlan_SaveInProgress;
  selectedDocuments: DocumentSearchResult[] = [];
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  listOfSelectedDocuments:string[]=[];
  linkedTrainingItem : any;
  
  @Input() userScopes: SelectedUserScopesDTO | undefined;
  @Input() userPUID: string | undefined;
  scope?:number;
  trainingItemsList : TrainingItemDetails[]=[];
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = [];
  displayDataCollected: string[] = [];
  trainingItemsDataToDisplay : string[] = [];
  userTrainingPlan : UserTrainingPlanDTO[] = [];
  feature:string = EmployeesTrainingPlanConstants.MyEmployee_TrainingPlan_Feature;
  employeeTrainingPlanDocumentDetails : string = EmployeesTrainingPlanConstants.EmployeeTrainingPlanDocumentDetails;
  trainingPlanDetails ?: TrainingPlanDetailsDto
  
  @ViewChild(DocumentLibrarySearchComponent)
    private docSearch!: DocumentLibrarySearchComponent;

  constructor(private messageService : MessageService,
    private employeesTrainingPlanPersistenceService : EmployeesTrainingPlanPersistenceService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private employeesTrainingPlanService : EmployeesTrainingPlanService){
    this.items = [
    {
        label: 'Add',
        command: this.add
    }
  ]
  }

  ngOnInit(): void {
    this.employeesTrainingPlanPersistenceService.TrainingPlanSaveInProgress$.
      subscribe((trainingPlanSaveStatus) => {
        this.isTrainingPlanSaveInProgress = trainingPlanSaveStatus;
      });
    this.employeesTrainingPlanPersistenceService.closeAndResetTrainingPlanSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetTrainingPlanSlider(); }
    })
  }

  onSelectionOrDeselection = (documents: DocumentSearchResult[]) => {
    let selectedDocumentsList: string[] = [];
    documents.forEach(element => {
      selectedDocumentsList.push(element.documentNumber);
    });
    this.displayDataCollected=[]
    this.displayDataCollected = selectedDocumentsList;
    this.selectedDocuments = [];
    this.selectedDocuments = cloneDeep(documents);
  }

  addTrainingPlanAndClose(){
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetTrainingPlanSlider(){
    this.selectedDocuments = [];
    this.displayDataCollected = [];
    this.documentSearchResult = [];
    this.showAddButton = false;
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }


  getLinkedItems(addAndClose:boolean)
  {
    this.eqmsScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount=0; 
    this.scope = this.userScopes?.eQMSPrimaryScope;

    // Directly validate and proceed without fetching existing training plan
    this.validateAndCreateOrUpdateTrainingPlan(addAndClose);
    this.docSearch.getLinkedItemsSelection();
  }

  validateAndCreateOrUpdateTrainingPlan(addAndClose:boolean){
    // Only validate that at least one item is selected
    if(this.displayDataCollected.length<=0)
    {
      this.validateToSelectAtleastOneTrainingItem();
      return;
    }

    // Proceed to get document details and validate scopes
    this.employeesTrainingPlanService.getLatestDocumentDetail(this.displayDataCollected)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: EmployeesTrainingPlanConstants.Severity_Err,
            summary: `${err.error}`,
            life: 20000 
          });
          return throwError(() => err);
        })
      ).subscribe((serviceData) => {
        this.getParentAndDescendantsScopesAndCompare(serviceData, addAndClose);
      });
  }

  validateToSelectAtleastOneTrainingItem(){
    this.errorCount=0;
    this.messageService.add({
      severity: EmployeesTrainingPlanConstants.Severity_Err,
      summary: `${EmployeesTrainingPlanConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      life: 20000
    });
    this.errorCount++;
  }




    //since scopes are not matching, we are trying to get its parent scopes and compare with selected form scopes
    getParentAndDescendantsScopesAndCompare(serviceData: any[], addAndClose: boolean) {
      const scopes: any[] =[];
      scopes.push(this.userScopes?.eQMSPrimaryScope);
      this.userScopes?.ancestors?.forEach((ele : number) => {
        scopes.push(ele);
      });

      //For descendants
      this.userScopes?.descendants?.forEach((ele : number) => {
        scopes.push(ele);
      });

      const matchingDocuments: any[] = [];
      const mismatchedDocuments: any[] = [];
      
      serviceData.forEach((data) => {
        const { eqmsScopes } = data;    
        const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
        if (hasMatch) {
          matchingDocuments.push(data);
        } else {
          mismatchedDocuments.push(data);
        }
      });
      if (mismatchedDocuments.length) {
        this.displayScopeValidationMessage(mismatchedDocuments);
      }
      if (matchingDocuments.length) {
        this.selectedItems(matchingDocuments);
        // Always call addTrainingPlan (backend will handle duplicates)
        this.addTrainingPlan(matchingDocuments, addAndClose);
      }
    }

    selectedItems(serviceData : any[]){
      if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
        this.trainingItemsDataToDisplay = serviceData;
      } else {
        this.trainingItemsDataToDisplay.push(...serviceData);
      }
    }

    addTrainingPlan(matchingDocuments : any[], addAndClose : boolean){
        this.employeesTrainingPlanPersistenceService.prepareDataForDocumentTrainingItem(matchingDocuments, this.userPUID);
        this.employeesTrainingPlanPersistenceService.addTrainingPlan(addAndClose);
    }

    displayScopeValidationMessage(mismatchedDocuments: any[]) {
      this.errorCount = 0;
      const documentNumbersString = mismatchedDocuments.map((document) => `  ${document.number}`).join(', ');
      const validationMessage = EmployeesTrainingPlanConstants.Selected_Documentscopes_Not_Matching_Error_Message.replace(
        'DocumentNumbers',
        `\n${documentNumbersString}`
      );
      this.messageService.add({
        severity: EmployeesTrainingPlanConstants.Severity_Err,
        summary: `${validationMessage}`,
        life: 20000 
      });
      this.errorCount++;  
    }

}

